import {
  FETCH_AGING_DASHBOARD,
  FETCH_AGING_DASHBOARD_SUCCESS,
  FETCH_AGING_DASHBOARD_FAILURE,
  FETCH_AGING_TABLE,
  FETCH_AGING_TABLE_SUCCESS,
  FETCH_AGING_TABLE_FAILURE,
  FETCH_AGING_ZONE_BREAKDOWN,
  FETCH_AGING_ZONE_BREAKDOWN_SUCCESS,
  FETCH_AGING_ZONE_BREAKDOWN_FAILURE,
  FETCH_COLLECTION_DAYS,
  FETCH_COLLECTION_DAYS_SUCCESS,
  FETCH_COLLECTION_DAYS_FAILURE,
  UPLOAD_AGING_ANALYSIS,
  UPLOAD_AGING_ANALYSIS_SUCCESS,
  UPLOAD_AGING_ANALYSIS_FAILURE,
  UPLOAD_COLLECTION_DAYS,
  UPLOAD_COLLECTION_DAYS_SUCCESS,
  UPLOAD_COLLECTION_DAYS_FAILURE,
  FETCH_SALES_TARGET,
  FETCH_SALES_TARGET_SUCCESS,
  FETCH_SALES_TARGET_FAILURE,
  UPLOAD_SALES_TARGET,
  UPLOAD_SALES_TARGET_SUCCESS,
  UPLOAD_SALES_TARGET_FAILURE,
} from '../constants/ActionsTypes'

export const fetchAgingDashboard = (seller) => ({
  type: FETCH_AGING_DASHBOARD,
  payload: { seller },
})

export const fetchAgingDashboardSuccess = (data) => ({
  type: FETCH_AGING_DASHBOARD_SUCCESS,
  payload: data,
})

export const fetchAgingDashboardFailure = (error) => ({
  type: FETCH_AGING_DASHBOARD_FAILURE,
  payload: error,
})

export const fetchAgingTable = (filters) => ({
  type: FETCH_AGING_TABLE,
  payload: filters,
})

export const fetchAgingTableSuccess = (data) => ({
  type: FETCH_AGING_TABLE_SUCCESS,
  payload: data,
})

export const fetchAgingTableFailure = (error) => ({
  type: FETCH_AGING_TABLE_FAILURE,
  payload: error,
})

export const fetchZoneBreakdown = (seller) => ({
  type: FETCH_AGING_ZONE_BREAKDOWN,
  payload: { seller },
})

export const fetchZoneBreakdownSuccess = (data) => ({
  type: FETCH_AGING_ZONE_BREAKDOWN_SUCCESS,
  payload: data,
})

export const fetchZoneBreakdownFailure = (error) => ({
  type: FETCH_AGING_ZONE_BREAKDOWN_FAILURE,
  payload: error,
})

export const fetchCollectionDays = (seller) => ({
  type: FETCH_COLLECTION_DAYS,
  payload: { seller },
})

export const fetchCollectionDaysSuccess = (data) => ({
  type: FETCH_COLLECTION_DAYS_SUCCESS,
  payload: data,
})

export const fetchCollectionDaysFailure = (error) => ({
  type: FETCH_COLLECTION_DAYS_FAILURE,
  payload: error,
})

export const uploadAgingAnalysis = (file) => ({
  type: UPLOAD_AGING_ANALYSIS,
  payload: file,
})

export const uploadAgingAnalysisSuccess = () => ({
  type: UPLOAD_AGING_ANALYSIS_SUCCESS,
})

export const uploadAgingAnalysisFailure = (error) => ({
  type: UPLOAD_AGING_ANALYSIS_FAILURE,
  payload: error,
})

export const uploadCollectionDays = (file) => ({
  type: UPLOAD_COLLECTION_DAYS,
  payload: file,
})

export const uploadCollectionDaysSuccess = () => ({
  type: UPLOAD_COLLECTION_DAYS_SUCCESS,
})

export const uploadCollectionDaysFailure = (error) => ({
  type: UPLOAD_COLLECTION_DAYS_FAILURE,
  payload: error,
})

export const fetchSalesTarget = (seller) => ({
  type: FETCH_SALES_TARGET,
  payload: { seller },
})

export const fetchSalesTargetSuccess = (data) => ({
  type: FETCH_SALES_TARGET_SUCCESS,
  payload: data,
})

export const fetchSalesTargetFailure = (error) => ({
  type: FETCH_SALES_TARGET_FAILURE,
  payload: error,
})

export const uploadSalesTarget = (file) => ({
  type: UPLOAD_SALES_TARGET,
  payload: file,
})

export const uploadSalesTargetSuccess = () => ({
  type: UPLOAD_SALES_TARGET_SUCCESS,
})

export const uploadSalesTargetFailure = (error) => ({
  type: UPLOAD_SALES_TARGET_FAILURE,
  payload: error,
})
